var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from '../../utils/apiUtils';
const GET_SET_COMPANIES = 'api/company';
const GET_SET_BILLING = 'api/billing';
/** Fresh, read-only billing state for an authorized company admin. */
export const getSubscriptionBillingStatus = function (data, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = Object.assign({ headers: { Authorization: `Bearer ${this.apiToken}` } }, ((options === null || options === void 0 ? void 0 : options.signal) ? { signal: options.signal } : {}));
            const query = generateQueryParamsStr(['companyId'], data);
            return yield this.axiosInstance.get(`${GET_SET_BILLING}/subscription/status?${query}`, config);
        }
        catch (error) {
            // Axios errors may contain authorization headers and hosted access links.
            console.error('Error fetching getSubscriptionBillingStatus');
            throw error;
        }
    });
};
export const getCompanyById = function (companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_COMPANIES}/${companyId}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getCompanyById:', error);
            throw error;
        }
    });
};
export const getCompanyOrdersMetrics = function () {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_COMPANIES}/metrics/orders`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getCompanyOrdersMetrics:', error);
            throw error;
        }
    });
};
export const getGarmentAttributeCatalogs = function (companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_COMPANIES}/${companyId}/garment-attribute-catalogs`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getGarmentAttributeCatalogs:', error);
            throw error;
        }
    });
};
export const getCFDIAddonStatus = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_BILLING}/cfdi/status?companyId=${encodeURIComponent(data.companyId)}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getCFDIAddonStatus:', error);
            throw error;
        }
    });
};
export const getAvailableSubscriptionPlans = function () {
    return __awaiter(this, arguments, void 0, function* (data = {}) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const params = new URLSearchParams();
            if (data.companyId) {
                params.set("companyId", data.companyId);
            }
            const query = params.toString();
            const response = yield this.axiosInstance.get(`${GET_SET_BILLING}/subscription/available-plans${query ? `?${query}` : ""}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getAvailableSubscriptionPlans:', error);
            throw error;
        }
    });
};
export const getAvailableBillingExtraPackages = function () {
    return __awaiter(this, arguments, void 0, function* (data = {}) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const params = new URLSearchParams();
            if (data.companyId) {
                params.set("companyId", data.companyId);
            }
            const query = params.toString();
            const response = yield this.axiosInstance.get(`${GET_SET_BILLING}/extra-packages${query ? `?${query}` : ""}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getAvailableBillingExtraPackages:', error);
            throw error;
        }
    });
};
